import { HORIZONTAL_MODE } from '../../const';

export const DEFAULT_ROWS_VALUE = 3;
export const DEFAULT_COLS_VALUE = 5;
export const DEFAULT_SHEET_NAME = 'value';
export const INITIAL_STATE = {
  isOpen: false,
  newRows: DEFAULT_ROWS_VALUE,
  newCols: DEFAULT_COLS_VALUE,
  mode: HORIZONTAL_MODE,
  metricRadioState: undefined,
  metricsSystems: undefined,
  currentMetric: undefined,
  data: [],
  selectedFiles: undefined
};
